<template>
  <div class="vote row justify-center">
    <div v-if="rate.doutores" class="column">
      <div
        v-if="rate.doutores && !ok"
        class="controls row justify-space align-center"
      >
        <button
          type="button"
          title="Avaliação anterior"
          @click="vote--"
          :disabled="vote > 0 ? false : true"
        >
          <i class="fa fa-chevron-left"></i>
        </button>

        <div>Avaliação {{ vote + 1 }}/{{ rate.doutores.length }}</div>
        <button
          :disabled="
            vote + 1 < rate.doutores.length && !rate.doutores[vote].stars.submit
              ? false
              : true
          "
          type="button"
          title="Próxima avaliação"
          @click="vote++"
        >
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
      <div class="content column">
        <div class="title text-center" v-if="!ok">
          Avalie seu atendimento com o Supporter:<br />
          {{ rate.doutores[vote].nome_doutor }}
        </div>
        <div class="title text-center" v-else>
          Avaliação gravada com sucesso!
        </div>

        <div v-if="!ok" class="solve column align-center">
          Seu problema foi resolvido?
          <div class="vote row justify-space align-center">
            <div
              :class="rate.doutores[vote].problema_resolvido ? 'active' : 'op'"
              @click="
                rate.doutores[vote].problema_resolvido = true;
                $forceUpdate();
              "
            >
              SIM
            </div>
            <div
              :class="!rate.doutores[vote].problema_resolvido ? 'active' : 'op'"
              @click="
                rate.doutores[vote].problema_resolvido = false;
                $forceUpdate();
              "
            >
              NÃO
            </div>
          </div>
        </div>
        <div v-if="!ok" class="stars column align-center">
          <div class="text-center">Como você avalia o atendimento?</div>
          <div class="row">
            <div
              class="star"
              v-for="(star, i) in rate.doutores[vote].stars"
              :key="i"
            >
              <template v-if="i < 5">
                <svg
                  v-if="!star.vote"
                  @mouseover="hover(i)"
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.5095 6.58604L13.0546 5.79327L10.6161 0.849715C10.5495 0.714363 10.44 0.604793 10.3046 0.538192C9.96516 0.370613 9.55266 0.510262 9.38294 0.849715L6.94446 5.79327L1.48958 6.58604C1.33919 6.60753 1.20169 6.67843 1.09641 6.78585C0.969142 6.91666 0.899011 7.09265 0.901428 7.27514C0.903845 7.45763 0.978613 7.6317 1.1093 7.75909L5.05598 11.6069L4.12356 17.0403C4.10169 17.1667 4.11568 17.2967 4.16393 17.4156C4.21219 17.5344 4.29277 17.6374 4.39656 17.7127C4.50034 17.7881 4.62317 17.8329 4.75112 17.842C4.87906 17.8512 5.00701 17.8243 5.12044 17.7644L9.99954 15.1991L14.8786 17.7644C15.0118 17.8353 15.1665 17.8589 15.3148 17.8331C15.6886 17.7687 15.94 17.4142 15.8755 17.0403L14.9431 11.6069L18.8898 7.75909C18.9972 7.65382 19.0681 7.51632 19.0896 7.36593C19.1476 6.98995 18.8855 6.6419 18.5095 6.58604Z"
                    fill="#F2F2F2"
                  />
                </svg>
                <svg
                  v-else
                  @click="
                    click = true;
                    hover(i, true);
                  "
                  @mouseleave="reset()"
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.5095 6.58604L13.0546 5.79327L10.6161 0.849715C10.5495 0.714363 10.44 0.604793 10.3046 0.538192C9.96516 0.370613 9.55266 0.510262 9.38294 0.849715L6.94446 5.79327L1.48958 6.58604C1.33919 6.60753 1.20169 6.67843 1.09641 6.78585C0.969142 6.91666 0.899011 7.09265 0.901428 7.27514C0.903845 7.45763 0.978613 7.6317 1.1093 7.75909L5.05598 11.6069L4.12356 17.0403C4.10169 17.1667 4.11568 17.2967 4.16393 17.4156C4.21219 17.5344 4.29277 17.6374 4.39656 17.7127C4.50034 17.7881 4.62317 17.8329 4.75112 17.842C4.87906 17.8512 5.00701 17.8243 5.12044 17.7644L9.99954 15.1991L14.8786 17.7644C15.0118 17.8353 15.1665 17.8589 15.3148 17.8331C15.6886 17.7687 15.94 17.4142 15.8755 17.0403L14.9431 11.6069L18.8898 7.75909C18.9972 7.65382 19.0681 7.51632 19.0896 7.36593C19.1476 6.98995 18.8855 6.6419 18.5095 6.58604Z"
                    class="bot"
                  />
                </svg>
              </template>
            </div>
          </div>
          <div class="text">{{ rate.doutores[vote].stars.text }}</div>
          <br /><br />
          <Button
            v-if="vote + 1 < rate.doutores.length"
            layout="remote-continue"
            :disabled="rate.doutores[vote].stars.submit"
            @click="goNext"
            >PRÓXIMA AVALIAÇÃO</Button
          >
          <Button
            v-if="vote + 1 == rate.doutores.length"
            layout="remote-continue"
            :disabled="rate.doutores[vote].stars.submit"
            @click="goRate"
            >ENVIAR AVALIAÇÃO</Button
          ><br /><br />
          <a href="/atendimento">
            <Button layout="remote-skip">CANCELAR</Button>
          </a>
        </div>
        <div v-if="ok" class="ok">
          Obrigado.<br /><br /><br /><br />
          <a href="/atendimento">
            <Button layout="green-go">Voltar para seus atendimentos</Button>
          </a>
        </div>
      </div>
    </div>

    <Status />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Status from "@/components/Status.vue";

export default {
  name: "Vote",
  props: { theme: Object },
  components: { Button, Status },
  data() {
    return {
      ok: false,
      problem: true,
      vote: 0,
      click: false,
      aux: [],
      rate: {},
    };
  },
  beforeMount() {
    let id = window.location.toString().split("id_job=")[1];
    this.GET_RATE(id).then((r) => {
      /*    this.rate = {
        id_job: 15,
        doutores: [
          {
            id_doutor: 10,
            nome_doutor: "doutor 01",
          },
          {
            id_doutor: 11,
            nome_doutor: "doutor 02",
          },
        ],
      }; */

      this.rate = r;

      if (this.rate.doutores) {
        for (let i in this.rate.doutores) {
          this.rate.doutores[i].problema_resolvido = true;
          this.rate.doutores[i].stars = {
            0: { vote: false, text: "Muito ruim" },
            1: { vote: false, text: "Ruim" },
            2: { vote: false, text: "Normal" },
            3: { vote: false, text: "Bom" },
            4: { vote: false, text: "Muito bom" },
            submit: true,
            text: "",
          };
        }
      }
    });
  },
  methods: {
    ...mapActions("general", ["GET_RATE", "SET_RATE"]),
    goNext() {
      this.click = false;
      this.vote++;
    },
    goRate() {
      this.SET_RATE(this.rate).then((r) => {
        if (r.status == 200 || r.status == 201) this.ok = true;
      });
    },
    reset(force) {
      if (force || !this.click) {
        this.rate.doutores[this.vote].nota = 0;
        this.rate.doutores[this.vote].stars = {
          0: { vote: false, text: "Muito ruim" },
          1: { vote: false, text: "Ruim" },
          2: { vote: false, text: "Normal" },
          3: { vote: false, text: "Bom" },
          4: { vote: false, text: "Muito bom" },
          submit: true,
          text: "",
        };
      }

      if (!force && this.click) {
        this.rate.doutores[this.vote].stars = this.aux[this.vote];
      }
      this.$forceUpdate();
    },
    hover(n, click) {
      this.aux[this.vote] = this.rate.doutores[this.vote].stars;
      this.reset(true);

      for (let i = 0; i <= n; i++) {
        this.rate.doutores[this.vote].stars[i].vote = true;
        this.rate.doutores[this.vote].stars.text =
          this.rate.doutores[this.vote].stars[i].text;
        this.rate.doutores[this.vote].nota++;

        if (click) {
          this.rate.doutores[this.vote].stars.submit = false;
          this.aux[this.vote] = this.rate.doutores[this.vote].stars;
        }
      }
      this.$forceUpdate();
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.vote {
  color: 373946;
  font-family: Work Sans;
  background: #fff;
  padding: 20px;
  /*  width: 320px; */
  .controls {
    font-size: 16px;
    button {
      border-radius: 5px;
      padding: 8px 10px;
    }
  }
  .content {
    background: #fcfcfc;
    margin-top: 10px;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 45px;
    max-width: 400px;
    .lia {
      margin-right: 19px;
    }
    .title {
      font-weight: 600;
      font-size: 21px;
      line-height: 23px;
    }
    .solve {
      font-size: 14px;
      margin-top: 35px;
      font-weight: 300;
      .vote {
        background: rgba(0, 0, 0, 0.05);
        color: rgba(0, 0, 0, 0.3);
        border-radius: 48px;
        height: 45px;
        font-size: 14px;
        font-weight: normal;
        padding: 0px 4px;
        width: 137px;
        margin-top: 10px;
        .op {
          border-radius: 48px;
          padding: 9px 20px;
          cursor: pointer;
          text-align: center;
          &:hover {
            color: #777;
            font-weight: bold;
          }
        }
      }
    }
    .stars {
      font-size: 14px;
      margin-top: 35px;
      font-weight: 300;
      .star {
        margin-top: 15px;
        svg {
          cursor: pointer;
          margin-right: 7px;
        }
      }
      .text {
        font-weight: bold;
        height: 20px;
      }
    }
    .ok {
      margin-top: 45px;
      text-align: center;
      color: $gray-6;
      span {
        color: $green-2;
      }
    }
  }
}
</style>
